import $ from 'jquery';
import stickybits from 'stickybits';
import slick from 'slick-carousel';
import magnificPopup from 'magnific-popup';


$(function() {


	/* Adding class on anchor that contains image
	********************************************/

	if ($('.c-article').length) {
		$('article p a:has(img), article .wp-caption a:has(img)').addClass('c-article__image-link');
		$('article img').closest('p').addClass('c-article__image-container');
	}


	/* Sticky sidebar
	********************************************/

	if ($('.js-sticky-sidebar').length) {
		const stickyHeaderHeight = $( '.site-header .main-nav' ).outerHeight( true );
		const stickyHeaderOffset = stickyHeaderHeight + 19;
		const stickySidebarHeight = $( '.js-sticky-sidebar' ).outerHeight( true );
		const stickySidebarVisibleHeight = $( '.js-sticky-sidebar .js-sticky-sidebar-visible' ).outerHeight( true );
		const stickySidebarOffset = stickyHeaderOffset - (stickySidebarHeight - stickySidebarVisibleHeight);

		$('.js-sticky-sidebar').css('top', stickySidebarOffset);
	}


	/* Sharing
	********************************************/

	if ($('.js-social-sharing').length) {
		$('.js-social-sharing .social-likes_expander').on('click', function (e) {
			e.preventDefault();
			$('.js-social-sharing').toggleClass('is-active');
		});
	}


	/* Sliders
	********************************************/

	if ($('.js-gallery-slider').length) {
		$('.js-gallery-slider').slick({
			mobileFirst: false,
			infinite: false,
			autoplay: false,
			adaptiveHeight: true,
			draggable: true,
			swipe: true,
			fade: false,
			variableWidth: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
			dotsClass: 'c-slider__dots',
			arrows: true,
			nextArrow: '<a href="" class="c-slider__arrow c-slider__arrow--next"></a>',
			prevArrow: '<a href="" class="c-slider__arrow c-slider__arrow--prev"></a>'
		});
	}


	/* Modals
	********************************************/

	if ($.fn.magnificPopup) {
		$('.c-article__image-link').not('[target="_blank"]').magnificPopup({
			type: 'image',
			closeOnContentClick: false,
			closeBtnInside: false,
			image: {
				verticalFit: true
			},
			closeMarkup: '<button title="%title%" type="button" class="mfp-close c-modal-close">&#215;</button>'
		});

		$('.js-gallery-slider').magnificPopup({
			delegate: '.gallery-item a',
			type: 'image',
			closeOnContentClick: false,
			closeBtnInside: false,
			gallery: {
				enabled: true,
				navigateByImgClick: true,
				arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow c-slider__arrow c-slider__arrow--%dir%"></button>',
				preload: [0,1] // Will preload 0 - before current, and 1 after the current image
			},
			image: {
				verticalFit: true
			},
			closeMarkup: '<button title="%title%" type="button" class="mfp-close c-modal-close">&#215;</button>'
		});

		// close modal
		$('body').on('click', '.js-modal-close', function (e) {
			e.preventDefault();
			$.magnificPopup.close();
		});
	}



});
